<template>
  <img
    :src="dataUrl"
    :alt="$attrs.alt || ''"
    :class="loaded ? 'site-image loaded' : 'site-image'"
    v-bind="$attrs"
    loading="lazy"
    @load="loaded = true"
    :width="placeholder ? placeholder.width : undefined"
    :height="placeholder ? placeholder.height : undefined"
  />
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    src: {
      type: String,
      required: true
    },
    placeholder: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      dataUrl: "",
      loaded: false
    };
  },

  mounted() {
    const { src, $el } = this;

    // if a placeholder with width and height properties is provided,
    // make a png matching those dimensions to fill the space before the image loads
    if (this.placeholder && this.placeholder.width && this.placeholder.height) {
      const temp = new Image();
      const placeholder = document.createElement("canvas");

      temp.onload = function() {
        placeholder.width = this.placeholder.width;
        placeholder.height = this.placeholder.height;

        if (!$el.width) {
          $el.src = placeholder.toDataURL();
        }
      };
    }

    const observer = new IntersectionObserver(([entry]) => {
      const img = $el;

      if (entry.isIntersecting) {
        // Element is in viewport
        img.src = src;
        observer.disconnect();
      }
    });
    observer.observe($el);

    this.$once("hook:beforeDestroy", () => {
      observer.disconnect();
    });
  }
};
</script>

<style></style>
